<div class="p-3 bg-dark bg-opacity-25 rounded-3" style="border: 1px solid rgba(255,255,255,0.07);">
    <h5 class="fw-bold text-white mb-2 fs-6">Enter Phone Number</h5>
    <p class="text-muted small mb-3">Add a phone number to help secure your account and verify your identity.</p>
    <form (ngSubmit)="onSubmit()">
        <!-- Phone Number Field -->
        <div class="mb-3">
            <label for="phoneInput" class="form-label text-muted small text-uppercase fw-bold mb-1" style="font-size: 0.75rem;">Phone Number</label>
            <div class="d-flex gap-2">
                <select class="form-select form-select-sm" style="width: 80px; height: 38px;">
                    <option>+1</option>
                    <option>+44</option>
                    <option>+33</option>
                    <option>+49</option>
                    <option>+81</option>
                </select>
                <input type="tel" id="phoneInput" class="form-control form-control-sm py-2" placeholder="123 456 7890" style="height: 38px;"
                    [ngModel]="phoneNumber()" (ngModelChange)="phoneNumber.set($event)" name="phoneNumber" required>
            </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex align-items-center gap-2 mt-3">
            <button type="button" class="btn btn-settings-cancel btn-sm px-3 py-1-5" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn btn-settings-danger btn-sm px-3 py-1-5 fw-bold">Save</button>
        </div>
    </form>
</div>
